import React from 'react'
import Text from './introduction.mdx'

export function Introduction() {
  return (
    <div className='ui vertical segment'>
      <div className='ui text container'>
        <Text />
      </div>
    </div>
  )
}
